import React, { useState, useEffect } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import Api from "./api/api";
import MyLoader from "./util/loader";
import MyStorage from "./util/storage";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";
import back from "../assets/back.png";
// import ConfirmPopup from "./util/confirm_popup";
import VideoCmp from "./VideoCmp";
// import ListItemContainer from "./common/ListItemContainer";
import useReorder from "../hooks/use-reorder";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
// import ListItemActionButton from "./common/ListItemActionButton";
import PageActionButton from "./common/PageActionButton";
import LibraryListItem from "./common/LibraryListItem";

const SpecialLibrary = () => {
  var history = useHistory();

  var library_type = "special";

  const [categories, setCategories] = useState([]);
  const [showAtTopLibrary, setShowAtTopLibrary] = useState("");
  const [models, setModels] = useState([]);
  const [parentCat, setParentCat] = useState(null);
  const [selectedCat, setSelectedCat] = useState(null);
  const [loader, setLoader] = useState(false);

  const [deleteCat, setDeleteCat] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  const { isReordering, toggleIsReordering, reorderedItems, onReorderEnd, saveOrdering } =
    useReorder({
      items: models,
      onSave: (data) =>
        Api.updateCategoryOrder({
          params: { data },
          onSuccess: () => {
            showToast("success", "Ordering is updated!");
            refetchCategories();
            setTimeout(() => toggleIsReordering(), 1000);
          },
          onError: () => {
            refetchCategories();
            toggleIsReordering();
          },
        }),
    });

  const handleConfirm = () => {
    console.log("Confirmed!");
    setShowDialog(false);
    deleteCategory(deleteCat);
  };

  const handleCancel = () => {
    console.log("Cancelled!");
    setShowDialog(false);
  };

  // load data
  useEffect(() => {
    console.log("useEffect");
    // console.log('old: ' + JSON.stringify(models));
    loadData();
    return () => {
      console.log("unmount");
      // clear cache
      localStorage.removeItem(library_type + "categories");
      localStorage.removeItem(library_type + "models");
      localStorage.removeItem(library_type + "selectedCat");
      localStorage.removeItem(library_type + "parentCat");
    };
  }, []);

  const goToParent = () => {
    // console.log('GO BACK');
    let current = parentCat;
    const rootId = current.parent_id + "";
    // console.log('rootId: ' + rootId);
    if (rootId === "0") {
      setSelectedCat(null);
      setParentCat(null);
      let models = getParentCats(categories);
      setModels(models);
      saveState(categories, models, null, null);
      console.log("NULL");
    } else {
      // find parent
      let root = null;
      for (let i = 0; i < categories.length; i++) {
        const category = categories[i];
        if (category.id + "" === rootId) {
          root = category;
        }
      }
      setSelectedCat(root);
      setParentCat(root);
      loadSubcategories(categories, root);
      console.log("NOT NULL");
    }

    setTimeout(() => {
      console.log("onBack parentCat: " + JSON.stringify(parentCat));
    }, 1000);
  };

  const saveState = (categories_, models, selectedCat, parentCat) => {
    setTimeout(() => {
      console.log("saveState");
      localStorage.setItem(library_type + "categories", JSON.stringify(categories));
      // console.log('saving models: '+JSON.stringify(models));
      localStorage.setItem(library_type + "models", JSON.stringify(models));
      if (selectedCat != null) {
        localStorage.setItem(library_type + "selectedCat", JSON.stringify(selectedCat));
      } else {
        localStorage.removeItem(library_type + "selectedCat");
      }
      if (parentCat != null) {
        localStorage.setItem(library_type + "parentCat", JSON.stringify(parentCat));
      } else {
        localStorage.removeItem(library_type + "parentCat");
      }
    }, 50);
  };

  const loadSubcategories = (categories, parentCat) => {
    setTimeout(() => {
      let models = [];
      if (parentCat == null) {
        // load parent categories
        console.log("3");
        models = getParentCats(categories);
        console.log("categories: " + categories.length);
        setModels(models);
      } else {
        // load subcategories
        console.log("4");
        const parentId = parentCat.id;
        let subCategories = [];
        for (let i = 0; i < categories.length; i++) {
          const category = categories[i];
          if (category.parent_id + "" === parentId + "") {
            subCategories = subCategories.concat(category);
          }
        }
        // console.log('size: ' + subCategories.length);
        models = subCategories;
        setModels(models);
      }
      saveState(categories, models, selectedCat, parentCat);
    }, 50);
  };

  const onCategoryPress = (model) => {
    // check if this category has subcategories
    const parentId = model.id;
    let subCategories = [];
    for (let i = 0; i < categories.length; i++) {
      const category = categories[i];
      if (category.parent_id + "" === parentId + "") {
        subCategories = subCategories.concat(category);
      }
    }

    if (subCategories.length > 0) {
      // load sub categories
      setSelectedCat(model);
      setParentCat(model);
      setModels(subCategories);
      saveState(categories, subCategories, model, model);
    } else {
      saveState(categories, models, selectedCat, parentCat);
      history.push({
        pathname: "/videos",
        state: { model: model, type: library_type },
      });
    }
  };

  const checkIsRootCat = (cat, cats) => {
    let isRoot = true;
    for (let j = 0; j < cats.length; j++) {
      if (cats[j].id + "" === cat.parent_id + "") {
        isRoot = false;
      }
    }
    return isRoot;
  };

  const getParentCats = (cats) => {
    let parentCats = [];
    for (let i = 0; i < cats.length; i++) {
      const cat = cats[i];
      if (cat.type === "special") {
        if (checkIsRootCat(cat, cats)) parentCats = parentCats.concat(cat);
      }
    }
    return parentCats;
  };

  const refetchCategories = () => {
    if (parentCat == null) setLoader(true);
    Api.getCategoriesAdmin(
      (response) => {
        setLoader(false);
        setCategories(response);
        loadSubcategories(response, parentCat);
      },
      () => {
        setLoader(false);
      }
    );
  };

  const refetchShowAtTopLibrary = () => {
    Api.getShowAtTopLibrary({
      onSuccess: (response) => {
        if (response.data) {
          setShowAtTopLibrary(response.data);
        }
      },
    });
  };

  const loadData = () => {
    const [categories, models] = ["categories", "models"].map((k) =>
      localStorage.getItem(library_type + k) == null
        ? []
        : JSON.parse(localStorage.getItem(library_type + k))
    );

    const [selectedCat, parentCat] = ["selectedCat", "parentCat"].map((k) =>
      localStorage.getItem(library_type + k) == null
        ? null
        : JSON.parse(localStorage.getItem(library_type + k))
    );

    setCategories(categories);
    setModels(models);
    setSelectedCat(selectedCat);
    setParentCat(parentCat);

    refetchCategories();
    refetchShowAtTopLibrary();
  };

  const addMainCategory = () => {
    saveState(categories, models, selectedCat, null);
    history.push({
      pathname: "/add-category",
      state: { model: {}, parent: null, type: library_type },
    });
  };

  const addCategory = (parent) => {
    saveState(categories, models, selectedCat, parentCat);
    history.push({
      pathname: "/add-category",
      state: { model: {}, parent: parent, type: library_type },
    });
  };

  const editCategory = (model) => {
    saveState(categories, models, selectedCat, parentCat);
    history.push({
      pathname: "/add-category",
      state: { model: model, parent: parentCat, type: library_type },
    });
  };

  const deleteCategory = (id) => {
    saveState(categories, models, selectedCat, parentCat);
    setLoader(true);
    Api.deleteCategory(
      id,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          showToast("success", "Category deleted!");
          refetchCategories();
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const setCategoryVisibility = (id, visibility) => {
    Api.setCategoryVisibility({
      params: { visibility, cat_id: id },
      onSuccess: (response) => {
        setLoader(false);
        if (response.status === "success") {
          showToast("success", "Visibility updated!");
          refetchCategories();
        }
      },
      onError: (error) => {
        setLoader(false);
      },
    });
  };

  const setShowAtTopLibraryApi = () => {
    Api.setShowAtTopLibrary({
      onSuccess: () => {
        showToast("success", "Show at top is updated!");
        refetchShowAtTopLibrary();
      },
      params: {
        config_value: library_type,
      },
    });
  };

  let title = "";
  if (library_type === "special") {
    title = "Special";
  }

  const renderLibraryListItem = (model, index) => {
    console.log(index);
    return (
      <LibraryListItem
        model={model}
        index={index}
        onPress={onCategoryPress}
        addCategory={addCategory}
        setCategoryVisibility={setCategoryVisibility}
        editCategory={editCategory}
        showDialog={showDialog}
        deleteCat={deleteCat}
        setDeleteCat={setDeleteCat}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        setShowDialog={setShowDialog}
      />
    );
  };

  const SortableItem = SortableElement(({ value, ...rest }) => {
    return renderLibraryListItem(value, rest.index2);
  });

  const SortableList = SortableContainer(({ items }) => (
    <div>
      {items.map((value, index) => {
        return <SortableItem key={value.id} index={index} value={value} index2={index} />;
      })}
    </div>
  ));

  const isShowAtTopLibrary = showAtTopLibrary === library_type;

  return (
    <div className="main">
      <div className="titlebar" style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}>
        <div style={{ color: "blue" }}>
          {parentCat == null ? "Category: Main" : "Category: " + parentCat.title}
        </div>
      </div>
      <div style={{ marginTop: 15 }}>
        {parentCat == null ? null : (
          <img
            onClick={() => {
              goToParent();
            }}
            src={back}
            style={{ width: 30, height: 30, marginTop: 10, marginRight: 10 }}
            className="icon-btn"
          />
        )}
        <div style={{ display: "flex" }}>
          {parentCat == null ? (
            <PageActionButton
              color={"black"}
              onClick={addMainCategory}
              text={"Add Main Category"}
            />
          ) : null}
          {isReordering ? (
            <>
              <PageActionButton
                color={"blue"}
                onClick={() => {
                  saveOrdering();
                  // toggleIsReordering();
                }}
                text={"Save Order"}
              />

              <PageActionButton color={"red"} onClick={toggleIsReordering} text={"Cancel"} />
            </>
          ) : (
            <PageActionButton color={"blue"} onClick={toggleIsReordering} text={"Reorder"} />
          )}

          {parentCat == null ? (
            <PageActionButton
              color={"gray"}
              onClick={() => history.push("/merge-cats")}
              text={"Merge Categories"}
            />
          ) : (
            <PageActionButton
              color={"blue"}
              onClick={() => {
                history.push({
                  pathname: "/upload-videos",
                  state: { model: parentCat, type: library_type },
                });
              }}
              text={"Add Videos"}
            />
          )}

          <PageActionButton
            color={"gray"}
            onClick={() => history.push("/assign-programs")}
            text={"Assign"}
          />

          <PageActionButton
            color={"gray"}
            onClick={() => history.push("/settings")}
            text={"Filter Settings"}
          />
          <PageActionButton
            color={"gray"}
            disabled={isShowAtTopLibrary}
            onClick={() => setShowAtTopLibraryApi()}
            text={"Show at top"}
          />
        </div>

        <div style={{ marginTop: 10 }}></div>
        {parentCat != null && (
          <div
            style={{
              marginTop: 0,
              padding: 10,
              backgroundColor: "gray",
              color: "white",
            }}
          >
            Sub Categories
          </div>
        )}

        {isReordering && <SortableList items={reorderedItems} axis="xy" onSortEnd={onReorderEnd} />}

        {!isReordering &&
          models.map((model, index) => {
            return renderLibraryListItem(model, index);
          })}

        {parentCat != null && (
          <div>
            <div
              style={{
                marginTop: 10,
                padding: 10,
                backgroundColor: "gray",
                color: "white",
              }}
            >
              Videos
            </div>
            <VideoCmp model={parentCat} />
          </div>
        )}
      </div>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default SpecialLibrary;
